<div class="shared-device-hint" [innerHTML]="text | translate"></div>
